import getContext from './get-context';
import getData from './get-data';
import putContext from './put-context';
import requestTopLevelCustomer from './request-top-level-customer';

const asyncThunks = {
  getContext,
  getData,
  putContext,
  requestTopLevelCustomer,
};

export default asyncThunks;
